import { createSelector } from 'reselect';
import { getMy } from '@src/containers/Session/selectors/getMy';
import { getProfileData } from './getProfileData';

export const getIsPrivate = createSelector(
	getProfileData,
	getMy,
	(data, my) => {
		if (!my?.id || !data) return false;
		return my.id === data.userId;
	},
);
